var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.571 4.833c1.587 0 2.875 1.308 2.875 2.917 0 1.61-1.288 2.916-2.875 2.916-1.586 0-2.875-1.307-2.875-2.916 0-1.61 1.289-2.917 2.875-2.917zm3.286 8.333c1.358 0 2.464 1.123 2.464 2.5 0 0-.046 1.479-.607 2.048-.657.666-3.027 1.642-5.143 1.619-2.273-.025-4.712-1.519-5.428-2.476-.164-.22-.322-1.19-.322-1.19 0-1.378 1.107-2.5 2.465-2.5 2.181 0 1.727.416 3.285.416 1.563 0 1.101-.417 3.286-.417zM11.57 4C9.53 4 7.874 5.68 7.874 7.75c0 2.07 1.656 3.75 3.696 3.75s3.697-1.68 3.697-3.75c0-2.07-1.656-3.75-3.697-3.75zm3.286 8.333c-2.372 0-1.823.417-3.286.417-1.458 0-.916-.417-3.285-.417C6.47 12.333 5 13.825 5 15.666V16c0 .258.08.749.286 1.143.162.312.535.572.857.858 0 0 2.143 1.963 5.428 2 3.19.034 5.143-1.43 5.143-1.43.308-.155.857-.57 1.143-1.142.285-.571.285-1.143.285-1.143v-.619c0-1.84-1.47-3.333-3.285-3.333z",
    fill: "#F48026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsUser);
export default __webpack_public_path__ + "static/media/settings-user.1a29e502ccdfc8a0d06095a14b1aa476.svg";
export { ForwardRef as ReactComponent };